<template>
  <v-card v-resize="onResize" class="ma-0 pa-0" height="100%">
    <v-card-text>
      <!--
      <p class="text-center title pb-0 mb-0 text-h4">FM Meters Data Display</p>
      -->
      <p class="headline font-weight-medium text-uppercase font-italic py-0 my-0" style="color:#C7A754"> Trends in
        energy usage </p>
    </v-card-text>
    <div id='mainGraph2' style='height:800px;'></div>
  </v-card>
</template>
<!--
  echarts warning regardng DOM width and heigh is due to
  no inital load as element is stuck within stepper component
  can be ignored
-->
<script>
import _ from 'lodash'
import shine from '@/components/plugins/echarts-theme-shine';

export default {
  props: ["rawData", "isLoading"],
  data: () => ({
    mainGraph: null,
  }),
  watch: {
    isLoading: {
      handler() {
        if (this.isLoading) {
          this.mainGraph.showLoading();
        } else {
          this.mainGraph.hideLoading();
        }
      }
    },
    '$store.state.KBEUI.unit': function () {
      this.set_Graph();
    },
    rawData: {
      handler() {
        this.set_Graph();
      }
    }
  },
  methods: {
    onResize() {  // calls echarts .resize function when viewing window changes
      if (this.mainGraph) _.debounce(this.mainGraph.resize, 100)()
    },
    set_Graph() {
      const colors = ['#5470C6', '#91CC75', '#EE6666'];
      let option = {
        color: colors,
        legend: {
          data: ['EUIMA', 'EUI', 'Energy Ratio']
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          axisTick: {
            alignWithLabel: true
          },
        },
        yAxis: [
          {
            type: 'value',
            name: 'EUI',
            position: 'left',
            alignTicks: true,
            offset: 0,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0]
              }
            },
          },
          {
            type: 'value',
            name: 'Energy Ratio',
            position: 'right',
            alignTicks: true,
            offset: 0,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1]
              }
            },
          },
        ],
        series: this.seriesArray,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        toolbox: {
          feature: {
            dataView: {},
            saveAsImage: {},
          }
        },
      };
      this.mainGraph.setOption(option)
    },
  },
  computed: {
    xAxis() {
      return this.rawData.Date
    },
    seriesArray() {
      let mult
      if (this.$store.state.KBEUI.unit == 'SI') {
        mult = 1
      } else {
        mult = 3.412 / 10.7639
      }

      var arr = [];
      arr.push({
        name: 'EUI Moving Average',
        type: 'line',
        data: this.rawData.EUIMA.map(x => x * mult),
        yAxisIndex: 0,
        itemStyle: {
          color: '#5470C6'
        },
      });
      arr.push({
        name: 'EUI',
        type: 'scatter',
        data: this.rawData.EUI_kWh_m2.map(x => x * mult),
        yAxisIndex: 0,
        itemStyle: {
          color: '#5470C6'
        },
      });
      arr.push({
        name: 'Energy Ratio Moving Average',
        type: 'line',
        data: this.rawData.ERMA,
        yAxisIndex: 1,
        itemStyle: {
          color: '#91CC75'
        },
      });
      arr.push({
        name: 'Energy Ratio',
        type: 'scatter',
        data: this.rawData.Energy_Ratio,
        yAxisIndex: 1,
        itemStyle: {
          color: '#91CC75'
        },
      });
      return arr
    },
  },
  async mounted() {
    echarts.registerTheme('shine', shine)
    this.mainGraph = echarts.init(document.querySelector('#mainGraph2'))

  }
}
</script>
